module.exports = {
    // Header Styles
    HeaderStyles: {
        fontWeight: "bold"
    }
}